"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("@zapier/constants");
/**
 * Returns formatted GLOBAL_APP_COUNT (e.g. 2,000+) if appCount param is >= than GLOBAL_APP_COUNT
 */
var globalAppCount = parseInt(constants_1.GLOBAL_APP_COUNT.replace(',', ''));
var formatTotalCount = function (appCount) {
    return Number(appCount) >= globalAppCount
        ? globalAppCount.toLocaleString() + "+"
        : Number(appCount).toLocaleString();
};
exports.default = formatTotalCount;
